import React from 'react';

import { useIntl } from 'react-intl-next';

import Button from '@atlaskit/button';

import messages from './messages';
import { type ShowMoreButtonProps } from './types';

export const ShowMoreButton: React.FC<ShowMoreButtonProps> = ({ onShowMore }) => {
	const { formatMessage } = useIntl();

	return (
		<Button
			onClick={onShowMore}
			// TODO: (from codemod) "link" and "subtle-link" appearances are only available in LinkButton, please either provide a href prop then migrate to LinkButton, or remove the appearance from the default button.
			// https://product-fabric.atlassian.net/browse/DSP-19035
			appearance="link"
		>
			{formatMessage(messages.showMoreButtonText)}
		</Button>
	);
};
